import BaseService from "../base";

class AppService extends BaseService {
  login = (params: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("login", params, success, error);
  };

  loginAdfs = (params: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("loginAdfs", params, success, error);
  };

  getMenu = (params: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("menu", params, success, error);
  };

  getRouting = (params: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("route", params, success, error);
  };

  getTaskGroupList = (params: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("taskGroupList", params, success, error);
  };

  getTaskStatusList = (params: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("categorieList", params, success, error);
  };

  checkStepPermission = (params: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("checkStepPermission", params, success, error);
  };

  getPagePermission = async (params: any, success: any, error: any) => {
    // @ts-ignore
    await this.sendRequest("getPagePermission", params, success, error);
  };

  getGuidelines = (success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getGuidelines", {}, success, error);
  };

  validateToken = (success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("validateToken", {}, success, error);
  };
}

const appService = new AppService();

export default appService;
